import {Component,  Vue, Ref} from 'vue-facing-decorator';
//import { ref } from "vue";
import ax from '@/utils/axios';


@Component({
    name: 'app-notif-menu',
})
export default class NotifMenu extends Vue{
    @Ref('menu') menuRef!: { toggle: (event: Event) => void };
   
    is_loading = false;

    //items : any = [
    //    {
    //        separator: true
    //    },
    //];

    get items(){
        return  this.$store.getters['notif/getNotif'] || [];
    }

    get total_notif(){
        return  this.$store.getters['notif/getTotal'] || 0;
    }

    mounted(){
        if( this.user.roles.includes('admin') || this.user.roles.includes('superadmin') ){
            this.$store.dispatch('notif/addItem',{
                name    : 'user_baru',
                label   : 'User Baru',
                icon    : ['fas', 'users'],
                total   : 0,
                to      : '/admin/user_new_list'
            } )
        }
        this.refresh();
    }

    refresh(){
        if( this.user.roles.includes('admin') || this.user.roles.includes('superadmin') ){
            this.getNotifNewUser();
        }
    }

    async getNotifNewUser(){
        this.is_loading     = true;
        await ax.get('admin/user/notif_new_user')
        .then((response) => {
            this.$store.dispatch('notif/setItemNotif',{ name : 'user_baru', value : response.data.data.total});
            this.is_loading = false;
        })
        .catch((response) => {
            console.log(response);
            this.is_loading = false;
        });
    }
 
    private toggle(event: Event): void {
        this.menuRef.toggle(event);
    }

    get user(): any {
        return this.$store.getters['user/getUser'];
    }


    
}